module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.17805/images/hubspot-academy-logo-color.svg"